export function LabeledValue({label,value})
{
    return( 
    <>
        <div className="flex gap-2">
            <div className="text-primary" style={{width:'80px'}}>{label}</div>
            <div>{value}</div>
        </div>
    </>
    );

}